import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-environment-badge',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './environment-badge.component.html',
  styleUrl: './environment-badge.component.scss',
})
export class EnvironmentBadgeComponent {
  readonly warningIcon = faTriangleExclamation;
  readonly rawEnvName = environment.envName?.trim().toLowerCase() || 'prod';
  readonly envName = this.rawEnvName === 'local' ? 'dev' : this.rawEnvName;
  readonly shouldShow = this.envName === 'dev' || this.envName === 'test';
  readonly envLabel = this.envName.toUpperCase();
}
